import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { caption, h6, paragraph } from '@helpers/typography';
import { PlayIcon } from '@stories/Components/Misc/VideoEmbed/VideoEmbed.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  max-width: 854px;

  .no-js-area {
    margin-bottom: ${fluid(15, 30)};
  }
`;
const VideoWrapper = styled.div `
  margin-bottom: ${fluid(15, 30)};
  position: relative;

  &:hover {
    ${PlayIcon} {
      &::before {
        background-color: ${rgba(brand.grey.grey11, 0.75)};
        transform: scale(1.1);
      }
    }
  }
`;
const Caption = styled.span `
  ${caption};
  margin-bottom: 0.75rem;
`;
const Title = styled.h3 `
  ${h6};
`;
const TextContent = styled.p `
  ${paragraph};
`;
const Cta = styled.button `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
`;
export const PastSeminarCardStyles = {
    Caption,
    Container,
    Cta,
    TextContent,
    Title,
    VideoWrapper,
};
